document.addEventListener('DOMContentLoaded', function () {
    const root = document.querySelector('.js-available-machines')
    if (!root) return

    const pills = root.querySelectorAll('.available-machines__pill')
    const panes = root.querySelectorAll('.available-machines__pane')

    const api = window.lpEmbla || {}
    const initEmblaFor = api.initEmblaFor || function () { }
    const destroyEmblaFor = api.destroyEmblaFor || function () { }

    const activePill = root.querySelector('.available-machines__pill.is-active')
    const switchBox = root.querySelector('.available-machines__switch-box')
    if (activePill && switchBox) {
        switchBox.dataset.active = activePill.dataset.series
    }

    panes.forEach(p => {
        const active = p.classList.contains('is-active')
        p.style.display = active ? '' : 'none'
        if (active) initEmblaFor(p)
    })

    pills.forEach(btn => {
        btn.addEventListener('click', () => {
            const series = btn.getAttribute('data-series')

            pills.forEach(b => {
                const isActive = b === btn
                b.classList.toggle('is-active', isActive)
                b.setAttribute('aria-selected', isActive ? 'true' : 'false')
            })

            const box = btn.closest('.available-machines__switch-box')
            if (box) box.dataset.active = series

            panes.forEach(pane => {
                const isTarget = pane.getAttribute('data-series') === series
                const wasActive = pane.classList.contains('is-active')

                if (wasActive && !isTarget) {
                    destroyEmblaFor(pane)
                    pane.classList.remove('is-active')
                    pane.style.display = 'none'
                }

                if (!wasActive && isTarget) {
                    pane.style.display = ''
                    pane.classList.add('is-active')
                    void pane.offsetHeight

                    requestAnimationFrame(() => {
                        initEmblaFor(pane)
                        const node = pane.querySelector('[data-embla]')
                        if (node && node._embla) node._embla.scrollTo(0, true)
                    })
                }
            })
        })
    })
})
